function loadImage(url) {
	return new Promise((resolve, reject) => {
		let image = new Image();
		image.onload = () => resolve(image);
		image.onerror = (e) => reject(e);
		image.src = url;
	});
}

function loadImages(urls) {
	return Promise.all(urls.map(loadImage));
}

export default loadImages;


// WEBPACK FOOTER //
// ./src/utils/loadImages.js